<template>
  <div v-if="dialogBox">
      <el-dialog
        :visible.sync="msgExampleDialog"
        width="30%"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div slot="title" class="header-title">
           <span>发送短信</span>
        </div>
        <div class="msgContent">
          <span>短信示例：</span>
          <div class="msg"></div>
        </div>  
        <span slot="footer" class="dialog-footer">
          <el-divider></el-divider>
          <el-button @click="dialogVisible = showHideSendMsgDialog(false)">取 消</el-button>
          <el-button type="primary" @click="confirm">确认发送</el-button>
        </span>
      </el-dialog>
      <el-dialog 
          :visible.sync="tipDialogFlag"
          width="24%"
          :show-close="false"
          :close-on-press-escape="false"
          class="tip"
        >
          <div slot="title" class="header-title">
           <span>提示</span>
          </div>
          <div class="tipMsg"></div>
          <span slot="footer" class="dialog-footer">
            <el-divider></el-divider>
            <el-button type="primary" @click="tipConfirm">确定</el-button>
          </span>
        </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        dialogBox:false,
        msgExampleDialog: false,
        message:'',
        tipDialogFlag:false,
        tipMessage:''
      };
    },
    props:{
      value:Boolean,
      studentId:String
    },
    beforeMount(){
      this.message=''
    },
    watch:{
      value:function(){
        this.dialogBox=this.value
        this.msgExampleDialog=this.value
        if(this.value){
          this.getMsgExample()
        }
      },
      tipDialogFlag:function(){
        if(this.tipDialogFlag){
          this.$nextTick(function(){
            document.querySelector('.tipMsg').innerHTML=this.tipMessage
          })
          
        }
      }
    },
    methods:{
      showHideSendMsgDialog: function(flag){
        this.msgExampleDialog = flag
        this.$emit('sendMsg', false) 
      },
      getMsgExample:function(){
        let params={id:this.studentId}
        this.$http.get(`/examination/phone/example`, {params}).then((res) => {
          if (res.data.success) {
            this.message=res.data.data.content
            document.querySelector('.msg').innerHTML=this.message
          }
        })
      },
      confirm:function(){
        this.$http.post(`/examination/send/daily/sms`, {id:this.studentId}).then((res) => {
          if (res.data.success) {
            this.message=res.data
            this.showHideSendMsgDialog(false)
            this.$message.success('发送成功！'); 
          }else{
            this.msgExampleDialog=false
            this.tipMessage=res.data.msg;
            this.tipDialogFlag=true
          } 
        }) 
      },
      tipConfirm:function(){
        this.tipDialogFlag=false
        this.$emit('sendMsg', false)
      }
    }   
  };
</script>
<style scoped>
.header-title{
    padding: 35px 0 0 30px;
    font-size: 34px;
    font-weight:bold;
}
.msgContent{
  width: 90%;
  line-height: 52px;
  margin: 0 auto;
  padding: 30px 30px;
  font-size: 32px;
  background-color: #F5F5F5;
}
.tipMsg{
  padding: 0 32px;
  line-height: 52px;
  font-size: 32px;
}
::v-deep .el-dialog__wrapper {
    position: fixed;
    top: 15%;
}
::v-deep  .el-dialog__body {
  padding: 20px 20px 0 20px;
}

</style>